/**
 * External Dependencies
 */
import Rellax from 'rellax';

import scrollBack from './utils/scrollBack';

import './partials/header';
import './partials/groups';
import './partials/articles';


import './blocks/featured-article';
import './blocks/steps';
import './blocks/topics';
import './blocks/aside';
import './blocks/intro-list';

document.addEventListener("DOMContentLoaded", () => {
  if (window.matchMedia( '(min-width: 900px)' ).matches) {
    let rellaxElements = document.querySelectorAll('.rellax');
    if (rellaxElements) {
      rellaxElements.forEach((rellaxElement) => {
        rellaxElement.classList.add('rellax--active');
      });

      new Rellax('.rellax', {
        speed: 1,
      });
    }
  }

  let footer = document.querySelector("footer");
  if (footer) {
    scrollBack(footer, document.documentElement);
  }

  let links = document.querySelectorAll('a');
  const address = window.location.hostname;
  if (links) {
    links.forEach((link) => {
      if (link.href.search(address) === -1) {
        link.setAttribute('target', '_blank');
      }
    });
  }
});
